import React from 'react';
import './BetaBanner.css';

function BetaBanner() {
  return (
    <div className="beta-banner">
      <div className="beta-banner-content">
        <span className="beta-banner-icon">⚠️</span>
        <span className="beta-banner-text">
          Сервис находится в тестовом режиме. Некоторые функции могут работать нестабильно.
        </span>
      </div>
    </div>
  );
}

export default BetaBanner;

